export const colorsInverted = {
  redInverted: 'bg-backgroundRed text-contentRed border border-contentRed',
  orangeInverted: 'bg-backgroundOrange text-contentOrange border border-contentOrange',
  amberInverted: 'bg-backgroundAmber text-contentAmber border border-contentAmber',
  yellowInverted: 'bg-backgroundYellow text-contentYellow border border-contentYellow',
  limeInverted: 'bg-backgroundLime text-contentLime border border-contentLime',
  greenInverted: 'bg-backgroundGreen text-contentGreen border border-contentGreen',
  emeraldInverted: 'bg-backgroundEmerald text-contentEmerald border border-contentEmerald',
  tealInverted: 'bg-backgroundTeal text-contentTeal border border-contentTeal',
  cyanInverted: 'bg-backgroundCyan text-contentCyan border border-contentCyan',
  skyInverted: 'bg-backgroundSky text-contentSky border border-contentSky',
  blueInverted: 'bg-backgroundBlue text-contentBlue border border-contentBlue',
  indigoInverted: 'bg-backgroundIndigo text-contentIndigo border border-contentIndigo',
  violetInverted: 'bg-backgroundViolet text-contentViolet border border-contentViolet',
  purpleInverted: 'bg-backgroundPurple text-contentPurple border border-contentPurple',
  fuchsiaInverted: 'bg-backgroundFuchsia text-contentFuchsia border border-contentFuchsia',
  pinkInverted: 'bg-backgroundPink text-contentPink border border-contentPink',
  roseInverted: 'bg-backgroundRose text-contentRose border border-contentRose'
}

export const colors = {
  default: 'bg-backgroundGray text-contentTertiary border border-borderPrimary',
  tertiary: 'bg-backgroundTertiary text-contentTertiary border border-borderPrimary',
  secondary: 'bg-backgroundSecondary text-contentSecondary border border-borderPrimary',

  // dark
  zinc: 'bg-contentTertiary text-backgroundGray border border-transparent',
  red: 'bg-contentRed text-backgroundRed border border-transparent',
  orange: 'bg-contentOrange text-backgroundOrange border border-transparent',
  yellow: 'bg-contentYellow text-backgroundYellow border border-transparent',
  lime: 'bg-contentLime text-backgroundLime border border-transparent',
  green: 'bg-contentGreen text-backgroundGreen border border-transparent',
  emerald: 'bg-contentEmerald text-backgroundEmerald border border-transparent',
  teal: 'bg-contentTeal text-backgroundTeal border border-transparent',
  cyan: 'bg-contentCyan text-backgroundCyan border border-transparent',
  sky: 'bg-contentSky text-backgroundSky border border-transparent',
  blue: 'bg-contentBlue text-backgroundBlue border border-transparent',
  indigo: 'bg-contentIndigo text-backgroundIndigo border border-transparent',
  violet: 'bg-contentViolet text-backgroundViolet border border-transparent',
  purple: 'bg-contentPurple text-backgroundPurple border border-transparent',
  fuchsia: 'bg-contentFuchsia text-backgroundFuchsia border border-transparent',
  pink: 'bg-contentPink text-backgroundPink border border-transparent',
  rose: 'bg-contentRose text-backgroundRose border border-transparent',
  amber: 'bg-contentAmber text-backgroundAmber border border-transparent ',
  // light
  ...colorsInverted,

  // TODO: tags
  category: 'bg-contentIndigo text-backgroundIndigo',
  skill: 'bg-backgroundIndigo text-contentIndigo border border-contentIndigo',

  // collection/article publication badges
  gray: 'bg-backgroundGray text-contentZinc border border-borderPrimary',
  transparent: 'bg-transparent text-contentZinc border border-transparent',

  darkBlue: 'bg-blue-600 text-contentInversePrimary border border-transparent'
}
